export default __webpack_public_path__ + "92bf12a0090a5e5be62547b90490b8ad.png";